import React from "react";
import "./Users_Counting_On_Us.css";

function Users_Counting() {
  const cards = [
    {
      icon: "/assets/images/downloading.png",
      iconAlt: "Download",
      iconClass: "arrow-down",
      value: "10K+",
      label: "DOWNLOADS",
    },
    {
      icon: "/assets/images/Layer_13.png",
      iconAlt: "Rating",
      iconClass: "app-rating",
      value: "4.5/5",
      label: "APP RATING",
    },
    {
      icon: "/assets/images/people.png",
      iconAlt: "Active Players",
      iconClass: "app-rating",
      value: "9K+",
      label: "ACTIVE PLAYERS",
    },
  ];

  return (
    <div className="users-counting-section">
      <div className="users-overlay">
        <div className="container">
          <div className="counting-holder">
            <div className="row mb-4">
              <div className="col-12">
                <h2 className="users-heading">
                  USERS <br /> COUNTING ON US
                </h2>
              </div>
            </div>

            <div className="card-holder row">
              {cards.map((card, index) => (
                <div className="col-12 col-md-4" key={index}>
                  <div className="count-card">
                    <div className="card-icon">
                      <img
                        src={card.icon}
                        alt={card.iconAlt}
                        className={card.iconClass}
                      />
                    </div>
                    <h3 className="description">{card.value}</h3>
                    <p className="paragraph">{card.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Users_Counting;
